// extracted by mini-css-extract-plugin
export default {"ctn":"control_ctn__jFQNg","textBox":"control_textBox__oqoyA","h":"control_h__rMUGP","video":"control_video__okjV1"};